require('./services/user-data-storage');

module.exports = 'user-data-storage';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/user-data-storage/index.js
 ** module id = 116
 ** module chunks = 1
 **/